/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InvoiceStatus {
	Open = 'Open',
	Closed = 'Closed',
	Forgiven = 'Forgiven',
	Paid = 'Paid',
}
